import { Heading } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurColor, getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const Container = styled.div`
    border-top: 1px solid ${getPurpurColor('gray200')};
    padding-top: ${getPurpurSpacing('600')};
`;

export const Title = styled(Heading)`
    margin-bottom: ${getPurpurSpacing('300')};
`;

export const ContactChoiceContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: ${getPurpurSpacing('200')};
    padding-bottom: ${getPurpurSpacing('600')};
`;
